import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PremiumTable, downloadBankInfo } from "../../Services/api";
import instance from "../../redux/api";
import { CommonButton } from "../common/commonButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  Grid,
  IconButton,
  Stack,
  TableContainer,
  TextField,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import { ViewAndEditEntity } from "./ViewAndEditEntity";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { toast } from "react-toastify";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterListIcon from "@mui/icons-material/FilterList";
import MyComponent from "../EntityTableMaintainance/EntityDetails";
import { AddPremium } from "./AddPremium";
import { PREMIUM_TABLE_DATA } from "../../utils/config";
import { CommonFilterSidebar, CommonSelect } from "../common";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import format from "date-fns/format";
import { commonToast } from "../common";
import { customDateFormat } from "../CashAllocation/utils";
import "../common/commonPageStyles.css";

//styles

const AssignBankStatementBar = {
  display: "flex",
  justifyContent: "space-between",
  height: 32,
  fontWeight: "400",
  marginTop: 10,
};
const editEntityUpdate = {
  width: "90px",
  padding: "18px 0px",
  borderRadius: "20px",
  gap: "8px",
};

const bankTransactionAddBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
};

const bankStatementSearchBar = {
  width: "180px",
  height: "30px",
  padding: "2px 5px 1px 15px",
  borderRadius: "7px",
  border: "1px solid #d2cccc",
  marginTop: "5px",
};

const dialogStyle = {
  maxWidth: "90vw",
  width: "90vw",
  margin: "auto",
};
const ResetSubmit = {
  justifyContent: "flex-end",
  paddingTop: "0px",
  marginRight: "12px",
};
const addBankTransactionReset = {
  backgroundColor: "white",
  width: "90px",
  padding: "16px 0px",
  borderRadius: "20px",
  gap: "8px",
  color: "black",
  border: "1px solid black",
};

const EditPageContainerTransactions = {
  padding: "10px",
  cursor: "default",
  width: "100%",
  marginLeft: "-10px",
};
const EditPageContainerTransactionsList = {
  display: "flex",
  justifyContent: "end",
  width: "100%",
  alignItems: "center",
  marginBottom: "10px",
};

const CloseIconStyle = {
  backgroundColor: "#3B3F44",
  color: "#ffff",
  height: "16px",
  width: "16px",
  padding: "7px 8px",
  borderRadius: "32px",
};
const addBankTransactionSubmit = {
  backgroundColor: "#1672DE",
  width: "90px",
  padding: "17px 0px",
  borderRadius: "13px",
  gap: "8px",
  color: "white",
  "&:hover": {
    backgroundColor: "#1565c0",
  },
};
const downloadBtn = {
  backgroundColor: "#1672DE",
  color: "white",
  borderRadius: "10px",
  padding: "10px 24px",
  fontWeight: "600",
  fontSize: "14px",
  textTransform: "none",
  minHeight: "40px",
  minWidth: "120px",
  boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
  "&:disabled": {
    backgroundColor: "#CCCCCC",
    color: "#ffffff",
    cursor: "not-allowed",
  },
};

export default function PremiumTableContainer() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [rows, setRows] = useState([{
    region: "",
    entity_number: "",
    msd_entity_number: "",
    entity_name: "",
    bank_name: "",
    account_number: "",
    account_opening_date: "",
    account_type: "",
    currency: "",
    msd_acct_number: "",
    msd_acct_name: "",
    prime_bank_account: ""
  }]);
  const [tableRows, setTableRows] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
  const [EntityDialog, setEntityDialog] = useState(false);
  const [editRow, setEditRow] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isCreated, setIsCreated] = useState(true);
  const [editId, setEditId] = useState("");
  // const [pageSize, setPageSize] = useState(5);
  // const [page, setPage] = useState(0);
  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const classes = useStyles();
  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Account_No: "",
    MSD_Account_No: "",
    Entity_Number: ""
  });
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if(isSearchPerformed){
        const { Account_No, MSD_Account_No, Entity_Number } = searchFieldsPrams;
        if (Account_No) {
          queryParams = `${queryParams}&accountNo=${Account_No}`;
        }
        if (MSD_Account_No) {
          queryParams = `${queryParams}&msdAccountNo=${MSD_Account_No}`;
        }
        if (Entity_Number) {
          queryParams = `${queryParams}&entityNumber=${Entity_Number}`;
        }
      }
      const response = await instance.get(
        `${PremiumTable}?${queryParams
        }`
      );
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  useEffect(() => {
    if (pageState?.total >= 5) {
      setPaginationCount(Math.floor(pageState.total / pageState?.pageSize));
    } else setPaginationCount(0);
  }, [pageState.total]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      setIsClearPerformed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearPerformed]);

  useEffect(() => {
    console.log("datataa", pageState.data);
  }, [pageState.data]);

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  const handleDialogClose = () => {
    setEntityDialog(false);
    setEditMode(false);
    setViewMode(false);

    if (!editMode && !viewMode) {
      setRows([
        {
          region: "",
          entity_number: "",
          msd_entity_number: "",
          entity_name: "",
          bank_name: "",
          account_number: "",
          account_opening_date: "",
          account_type: "",
          currency: "",
          msd_acct_number: "",
          msd_acct_name: "",
          prime_bank_account: ""
        }
      ]);
      setSelectedRows([false]);
      setValidationStatus([true]);
    }
    else if (editMode) {
      setValidationStatus([true]);
      setCurrentUpdatedFiledsInEditMode({});
    }
  }

  const handleFieldsInputChange = (name, value) => {
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: value ?? "",
    });
    if (isSearchPerformed && !value) {
      const searchFields = searchFieldsPrams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value)) {
        handleClearSearchList();
      }
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { Account_No, MSD_Account_No, Entity_Number } = searchFieldsPrams;
    if (Account_No !== "" || MSD_Account_No !== "" || Entity_Number !== "") {
      disabled = false;
    }
    return disabled;
  };

  const handleSearchPremiumTableList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const { Account_No, MSD_Account_No, Entity_Number } = searchFieldsPrams;
      if (Account_No) {
        queryParams = `${queryParams}&accountNo=${Account_No}`;
      }

      if (MSD_Account_No) {
        queryParams = `${queryParams}&msdAccountNo=${MSD_Account_No}`;
      }

      if (Entity_Number) {
        queryParams = `${queryParams}&entityNumber=${Entity_Number}`;
      }

      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${PremiumTable}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        console.log("broker", response);
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1
        }));
        setIsSearchPerformed(true);
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      console.log("err", err);
    }
  };

  const handleClearSearchList = () => {
    // loadData();
    setIsSearchPerformed(false);
    setSearchFieldsPrams({
      Account_No: "",
      MSD_Account_No: "",
      Entity_Number: "",
    });
    setPageState((old) => ({
      ...old,
      page: 1
    }));
    setIsClearPerformed(true);
  };

  const handleApplyFilters = () => {
    handleSearchPremiumTableList();
  };

  const handleClearFilters = () => {
    handleClearSearchList();
  };

  // const handleSearch = (e) => {
  //   const value = e.target.value;
  //   setSearchText(value);
  //   let filteredData;
  //   if (value.trim() === '') {
  //     loadData();
  //     filteredData = tableRows;
  //   } else {
  //     filteredData = tableRows.filter((row) =>
  //       columns.some((column) => {
  //         const cellValue = row[column.field];
  //         if (Array.isArray(cellValue)) {
  //           // Check if the array is not null
  //           if (cellValue !== null && cellValue !== undefined) {
  //             // Check if any property within the objects in the array includes the search value
  //             return cellValue.some((item) =>
  //               Object.values(item).some(
  //                 (propValue) =>
  //                   propValue !== undefined &&
  //                   propValue !== null &&
  //                   propValue.toString().includes(value)
  //               )
  //             );
  //           }
  //         } else if (cellValue !== undefined && cellValue !== null) {
  //           // For non-array fields, continue with the existing logic
  //           return cellValue.toString().includes(value);
  //         }
  //         return false;
  //       })
  //     );
  //   }
  //   setTableRows(filteredData);
  // };

  useEffect(() => {
    if (selectAll) {
      const updatedSelectedRows = [...selectedRows];
      updatedSelectedRows.fill(selectAll);
      setSelectedRows(updatedSelectedRows);
    }
  }, [selectAll]);

  const handleCheckboxChange = (index, isChecked) => {
    const updatedSelectedRows = [...selectedRows];
    updatedSelectedRows[index] = isChecked;

    // Check the number of selected rows
    const selectedRowCount = updatedSelectedRows.filter(Boolean).length;

    setSelectedRows(updatedSelectedRows);
    setSelectAll(selectedRowCount === rows.length);
  };

  const handleActionButton = (rowData, isEditMode) => {
    const emptyRows = Array.from({ length: rows.length }, () => ({
      region: "",
      entity_number: "",
      msd_entity_number: "",
      entity_name: "",
      bank_name: "",
      account_number: "",
      account_opening_date: "",
      account_type: "",
      currency: "",
      msd_acct_number: "",
      msd_acct_name: "",
      prime_bank_account: ""
    }));
    if (rowData && isEditMode) {
      // Pre-fill the empty row with data for editing
      setRows([{ ...rowData }]);
      setEditRow(rowData);
      setEditMode(true);
      setEditId(rowData.id);
      setIsCreated(false);
    } else if (rowData && !isEditMode) {
      setRows([rowData]);
      setViewMode(true);
    } else {
      // If no rowDataForEdit is provided, it means we are in add mode
      setRows(emptyRows);
      setIsCreated(true);
      setEntityDialog(true);
    }
    setEntityDialog(true);
    if (rowData) {
      setIsCreated(false);
    } else {
      setIsCreated(true);
    }
  };

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list["Admin Table Maintenance"];

  const columns = [
    { field: "id", headerName: "ID", width: 40, headerAlign: "center" },
    {
      field: "region",
      headerName: "Region",
      width: 100,
      headerAlign: "center",
    },
    {
      field: "entity_number",
      headerName: "Entity Number",
      width: 120,
      headerAlign: "center",
    },
    {
      field: "msd_entity_number",
      headerName: "MSD Entity Number",
      width: 150,
      headerAlign: "center",
    },
    {
      field: "entity_name",
      headerName: "Entity Name",
      width: 140,
      headerAlign: "center",
    },
    {
      field: "bank_name",
      headerName: "Bank Name",
      width: 140,
      headerAlign: "center",
    },
    {
      field: "account_number",
      headerName: "Account Number",
      width: 140,
      headerAlign: "center",
    },
    {
      field: "account_opening_date",
      headerName: "Account Opening Date",
      width: 160,
      headerAlign: "center",
      valueFormatter: (params) => {
        return params?.value ? customDateFormat(params?.value) : "";
      },
    },
    {
      field: "account_type",
      headerName: "Account Type",
      width: 120,
      headerAlign: "center",
    },
    {
      field: "currency",
      headerName: "Currency",
      width: 120,
      headerAlign: "center",
    },
    {
      field: "msd_acct_number",
      headerName: "MSD Account Number",
      width: 170,
      headerAlign: "center",
    },
    {
      field: "msd_acct_name",
      headerName: "MSD Account Name",
      width: 170,
      headerAlign: "center",
    }, {
      field: "prime_bank_account",
      headerName: "Prime Bank Account",
      width: 170,
      headerAlign: "center",
    },
    {
      field: "created_by",
      headerName: "Created By",
      width: 140,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    {
      field: "updated_by",
      headerName: "Last Modified By",
      width: 150,
      headerAlign: "center",
      valueGetter: (params) => params?.value ?? "-"
    },
    ...(userData?.role !== "CC Processor" ? [{
      field: "actions",
      headerName: "Actions",
      width: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {UserAuthorisation?.["View"] === "Y" && (
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
            {UserAuthorisation?.["Edit"] === "Y" && (
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => handleActionButton(params.row, true)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <EditNoteIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    }] : [
      {
        field: "actions",
        headerName: "Actions",
        width: 100,
        headerAlign: "center",
        align: "center",
        sortable: false,
        renderCell: (params) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Tooltip title="View">
                <IconButton
                  onClick={() => handleActionButton(params.row, false)}
                  sx={{
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "8px",
                    padding: "6px",
                    width: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.2)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 8px rgba(22, 114, 222, 0.2)",
                    },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      }
    ]),
  ];
  // const loadData = async () => {
  //   try {
  //     setIsApiCallInprogress(true);
  //     const resp = await instance.get(PremiumTable);
  //     setIsApiCallInprogress(false);
  //     if (resp.status === 200) {
  //       const sortedData = resp.data.sort((a, b) => b.id - a.id);
  //       setTableRows(sortedData);
  //     } else {
  //       setTableRows([]);
  //     }
  //   } catch (err) {
  //     setIsApiCallInprogress(false);
  //     console.error("err", err);
  //   }
  // };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleApplyFilters();
    }
  };

  const handleInputChange = (index, colName, value) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      updatedRows[index][colName] = value;
      setRows(updatedRows);
      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedSelectedRows = new Array(rows.length).fill(isChecked);

    setSelectedRows(updatedSelectedRows);
    setSelectAll(isChecked);
  };

  const handleAddRow = () => {
    setRows([...rows, {
      region: "",
      entity_number: "",
      msd_entity_number: "",
      entity_name: "",
      bank_name: "",
      account_number: "",
      account_opening_date: "",
      account_type: "",
      currency: "",
      msd_acct_number: "",
      msd_acct_name: "",
      prime_bank_account: ""
    }]);
    setSelectedRows([...selectedRows, false]);
  };

  useEffect(() => {
    const selectedRowCount = selectedRows.filter(Boolean).length;
    if (selectedRowCount < rows.length) {
      setSelectAll(false)
    }
  }, [rows, selectedRows])

  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows(selectedRows.filter((ele) => !ele));
    setSelectAll(false);
  };

  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (!row || !row.region || row.region.trim() === "") {
      fieldValidations.region = "This field is required";
    }
    if (!row || !row.entity_number || row.entity_number.trim() === "") {
      fieldValidations.entity_number = "This field is required";
    }
    if (!row || !row.msd_entity_number || row.msd_entity_number.trim() === "") {
      fieldValidations.msd_entity_number = "This field is required";
    }
    if (!row || !row.entity_name || row.entity_name.trim() === "") {
      console.log("entity name");
      fieldValidations.entity_name = "This field is required";
    }
    if (!row || !row.bank_name || row.bank_name.trim() === "") {
      console.log("bank name");
      fieldValidations.bank_name = "This field is required";
    }
    // commented on July 2, 2024
    // if (!row || !row.binding_aggrement_type || row.binding_aggrement_type.trim() === "") {
    //   console.log("binding agree type")
    //   fieldValidations.binding_aggrement_type = "This field is required";
    // }
    if (!row || !row.account_type || row.account_type.trim() === "") {
      console.log("account type");
      fieldValidations.account_type = "This field is required";
    }
    if (!row || !row.currency || row.currency.trim() === "") {
      console.log("currency");
      fieldValidations.currency = "This field is required";
    }

    if (!row || !row.msd_acct_number || row.msd_acct_number.trim() === "") {
      console.log("mad accnt number");
      fieldValidations.msd_acct_number = "This field is required";
    }

    if (!row || !row.msd_acct_name || row.msd_acct_name.trim() === "") {
      console.log("msd accnt name");
      fieldValidations.msd_acct_name = "This field is required";
    }

    if (!row || !row.account_number || row.account_number.trim() === "") {
      console.log("account num");
      fieldValidations.account_number = "This field is required";
    }

    if (!row || !(row.prime_bank_account === true || row.prime_bank_account === false)) {
      console.log("prime bank account");
      fieldValidations.prime_bank_account = "This field is required";
    }
    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };
  const handleSubmit = async () => {
    const areRowsValid = rows
      .map((_, index) => validateRow(index))
      .every((value) => value);

    let editModeObj = {};
    if (!editMode) {
      // Add Mode
    } else {     
      editModeObj.id = editRow?.id;
      editModeObj["updated_by"] = userData?.user_name ?? "";
      editModeObj = { ...editModeObj, ...currentUpdatedFiledsInEditMode };
    }

    if (!areRowsValid) {
      // If any row is invalid, stop the submission and display an error
      commonToast("error", "Please fill all required fields.");
      return;
    }
    try {
      let response;
      if (editMode) {
        response = await instance.patch(
          PremiumTable + editId + "/",
          editModeObj
        );
        // clear preiously updated stored data
        setCurrentUpdatedFiledsInEditMode({});
      } else {
        // const flattenedRows = rows.flat();
        rows.forEach((item) => {
          item.created_by = userData?.user_name ?? "";
        })
        response = await instance.post(PremiumTable, rows);
      }
      if (response) {
        if (editMode) {
          commonToast("success", "Updated successfully !");
        } else {
          commonToast("success", "Submission successful !");
        }

        // clean up
        cleanupTransactionData();
      }
    } catch (err) {
      commonToast("error", "Submission failed. Please try again.");
    }
  };

  const cleanupTransactionData = () => {
    handleDialogClose();
    loadData();
  };

  const handleReset = () => {
    const emptyRows = Array.from(
      { length: rows.length },
      () => ({
        region: "",
        entity_number: "",
        msd_entity_number: "",
        entity_name: "",
        bank_name: "",
        account_number: "",
        account_opening_date: "",
        account_type: "",
        currency: "",
        msd_acct_number: "",
        msd_acct_name: "",
        prime_bank_account: ""
      })
    );
    setRows(emptyRows);
    setSelectAll(false);
    setValidationStatus(Array.from({ length: rows.length }, () => true));
    setSelectedRows(selectedRows.fill(false))
  };


  const handleDownloadBtnClick = () => {
    setIsDownloadInProgress(true);
    try {
      instance
        .get(`${downloadBankInfo}`, { responseType: "blob" })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          const fileName = `BankInformation_${format(new Date(), "dd-MM-yyyy")}`
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setIsDownloadInProgress(false);
          commonToast("success", "Bank Information data has been downloaded successfully");
        }).catch((err) => {
          console.log(err);
          setIsDownloadInProgress(false);
          commonToast("error", "Bank Information data could not be downloaded");
        });
    } catch (error) {
      setIsDownloadInProgress(false);
      console.log(error);
      commonToast("error", "Bank Information data could not be downloaded");
    }
  }
  return (
    <>
      <style>
        {`
          /* Override DataGrid column headers to blue theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders {
            background-color: #f8f9fa !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .MuiDataGrid-root .MuiDataGrid-columnHeader {
            background-color: transparent !important;
            color: #1672DE !important;
          }
          /* Override DataGrid selection colors to blue - override MUI theme primary color */
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover,
          .MuiDataGrid-root .MuiDataGrid-row[aria-selected="true"]:hover {
            background-color: rgba(22, 114, 222, 0.12) !important;
          }
          .MuiDataGrid-root .MuiDataGrid-row:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          /* Override any orange/yellow colors from theme */
          .MuiDataGrid-root .MuiDataGrid-columnHeaders[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-columnHeader[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="#FF"],
          .MuiDataGrid-root .MuiDataGrid-row.Mui-selected[style*="ff5"] {
            background-color: rgba(22, 114, 222, 0.08) !important;
          }
        `}
      </style>
    <div style={Container}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "textInput",
              label: "Account No / Bank Name",
              placeholder: "Enter Details Here",
              value: searchFieldsPrams?.Account_No || "",
              onChange: (value) => handleFieldsInputChange("Account_No", value),
              onKeyUp: (e) => {
                if (e.code === "Enter") {
                  handleApplyFilters();
                }
              },
            },
            {
              type: "textInput",
              label: "Entity Number",
              placeholder: "Enter entity number Here",
              value: searchFieldsPrams?.Entity_Number || "",
              onChange: (value) => handleFieldsInputChange("Entity_Number", value),
              onKeyUp: (e) => {
                if (e.code === "Enter") {
                  handleApplyFilters();
                }
              },
            },
          ]}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          isLoading={pageState?.isLoading}
          isFilterDisabled={isFilterBtnDisable()}
        />

        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
          Bank Information Table
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {UserAuthorisation?.["Creation"] === "Y" && (
            <>
            <CommonButton
              text="Add"
              handleClick={() => handleActionButton()}
              sx={bankTransactionAddBtn}
                    hoverColor="#1565c0"
            />
                  <CommonButton
              text="Export"
              handleClick={handleDownloadBtnClick}
              sx={downloadBtn}
                    hoverColor="#1565c0"
              disabled={isDownloadInProgress}
                  />
            </>
          )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
        sx={{
              flex: 1,
          display: "flex",
              flexDirection: "column",
              minHeight: 0,
          position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading}
          rows={pageState?.data ?? []}
          columns={columns}
          rowCount={pageState?.total}
          keepNonExistentRowsSelected
          disableSelectionOnClick
          pagination
          paginationMode="server"
          getRowId={(row) => row?.id}
          page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              pageSizeOptions={[10, 25, 50, 100]}
              onPaginationModelChange={(model) => {
                setPageState((old) => ({
                  ...old,
                  page: model.page + 1,
                  pageSize: model.pageSize,
                }));
          }}
          components={{
                Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                    No Bank Information Records
              </Stack>
            ),
          }}
          sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "#1672DE",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "#1672DE",
                  },
                },
            "& .MuiDataGrid-columnHeader[data-field='actions']": {
              minWidth: toggle?.isOpen
                    ? "175.137px !important"
                    : "203px !important",
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08) !important",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12) !important",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  borderBottom: "none",
                  backgroundColor: "#f8f9fa",
                  minHeight: "56px",
                  maxHeight: "56px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "16px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                },
              }}
            />
          </Box>
        </Box>
      </div>
      {/* // Commented on July 2 2024 
      <MyComponent /> 
      */}
      <Dialog
        open={EntityDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{ 
          style: dialogStyle,
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          }
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ 
            cursor: "default", 
            paddingBottom: "0px",
            backgroundColor: "#ffffff",
            color: "#1672DE",
            fontWeight: "600",
            fontSize: "20px",
            padding: "20px 24px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          {viewMode
            ? "View Bank Information"
            : editMode
              ? "Edit Bank Information"
              : "Add Bank Information"}
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 12,
              top: 12,
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(22, 114, 222, 0.1)",
                color: "#1672DE",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ 
            overflowX: "hidden", 
            padding: "24px",
            backgroundColor: "#ffffff",
          }}
        >
          <div elevation={4} style={EditPageContainerTransactions}>
            {!editMode && !viewMode && (
              <div style={EditPageContainerTransactionsList}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <CommonButton
                    text="Add"
                    handleClick={handleAddRow}
                    icon={<AddIcon sx={{ ml: 0.5 }} />}
                    hoverColor="#1565c0"
                    sx={{
                      backgroundColor: "#1672DE",
                      color: "white",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      boxShadow: "0 2px 8px rgba(22, 114, 222, 0.2)",
                      "&:hover": {
                        backgroundColor: "#1565c0 !important",
                        boxShadow: "0 4px 12px rgba(22, 114, 222, 0.3)",
                        transform: "translateY(-1px)",
                      },
                      "&:active": {
                        backgroundColor: "#1565c0 !important",
                      },
                      "&:focus": {
                        backgroundColor: "#1672DE !important",
                        outline: "none",
                      },
                    }}
                  />
                  <CommonButton
                    text="Delete"
                    handleClick={handleDeleteRow}
                    disabled={selectedRows.filter(Boolean).length === 0}
                    icon={<DeleteIcon sx={{ ml: 0.5 }} />}
                    hoverColor="rgba(244, 67, 54, 0.1)"
                    sx={{
                      backgroundColor: "transparent",
                      color: "#f44336",
                      border: "1px solid #f44336",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontWeight: "600",
                      fontSize: "14px",
                      textTransform: "none",
                      minHeight: "36px",
                      "&:hover": {
                        backgroundColor: "rgba(244, 67, 54, 0.05)",
                        borderColor: "#d32f2f",
                        color: "#d32f2f",
                      },
                      "&:disabled": {
                        backgroundColor: "transparent",
                        color: "rgba(0, 0, 0, 0.26)",
                        borderColor: "#e0e0e0",
                      },
                    }}
                  />
                </div>
              </div>
            )}
            {isCreated ? (
              <TableContainer style={{ maxHeight: "300px" }}>
                <AddPremium
                  selectAll={selectAll}
                  handleInputChange={handleInputChange}
                  handleSelectAll={handleSelectAll}
                  rows={rows}
                  // handleBlur={handleBlur}
                  handleCheckboxChange={handleCheckboxChange}
                  validationStatus={validationStatus}
                  selectedRows={selectedRows}
                />
              </TableContainer>
            ) : (
              <>
                {rows?.map((row, index) => (
                  <Grid display={"flex"} flexDirection={"column"}>
                    <ViewAndEditEntity
                      row={row}
                      index={index}
                      viewMode={viewMode}
                      validationStatus={validationStatus}
                      editMode={editMode}
                      handleInputChange={handleInputChange}
                    />
                  </Grid>
                ))}
              </>
            )}
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: "#ffffff",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {viewMode ? null : (
            <>
              {isCreated && (
                <CommonButton
                  text="Reset"
                  handleClick={() => handleReset()}
                  disabled={editMode}
                  hoverColor="rgba(22, 114, 222, 0.05)"
                  sx={{
                    backgroundColor: "transparent",
                    color: "#1672DE",
                    border: "1px solid #1672DE",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.05)",
                      borderColor: "#1565c0",
                      color: "#1565c0",
                    },
                    "&:disabled": {
                      backgroundColor: "transparent",
                      color: "rgba(0, 0, 0, 0.26)",
                      borderColor: "#e0e0e0",
                    },
                  }}
                />
              )}
              {editMode && (
                <CommonButton
                  text="Update"
                  handleClick={handleSubmit}
                  disabled={Object.keys(currentUpdatedFiledsInEditMode)?.length <= 0}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                    "&:disabled": {
                      backgroundColor: "#e0e0e0",
                      color: "#9e9e9e",
                      boxShadow: "none",
                      transform: "none",
                    },
                  }}
                />
              )}
              {!editMode && !viewMode && (
                <CommonButton
                  text="Submit"
                  handleClick={handleSubmit}
                  hoverColor="#1565c0"
                  sx={{
                    backgroundColor: "#1672DE",
                    color: "white",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    fontSize: "14px",
                    textTransform: "none",
                    minHeight: "40px",
                    minWidth: "120px",
                    boxShadow: "0 4px 16px rgba(22, 114, 222, 0.3)",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      boxShadow: "0 6px 24px rgba(22, 114, 222, 0.4)",
                      transform: "translateY(-1px)",
                    },
                  }}
                />
              )}
              <CommonButton
                text="Cancel"
                handleClick={handleDialogClose}
                hoverColor="rgba(22, 114, 222, 0.05)"
                sx={{
                  backgroundColor: "transparent",
                  color: "#1672DE",
                  border: "1px solid #1672DE",
                  borderRadius: "10px",
                  padding: "10px 24px",
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "none",
                  minHeight: "40px",
                  minWidth: "120px",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.05)",
                    borderColor: "#1565c0",
                    color: "#1565c0",
                  },
                }}
              />
            </>
          )}
          {viewMode && (
            <CommonButton
              text="Close"
              handleClick={handleDialogClose}
              hoverColor="rgba(22, 114, 222, 0.05)"
              sx={{
                backgroundColor: "transparent",
                color: "#1672DE",
                border: "1px solid #1672DE",
                borderRadius: "10px",
                padding: "10px 24px",
                fontWeight: "600",
                fontSize: "14px",
                textTransform: "none",
                minHeight: "40px",
                minWidth: "120px",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.05)",
                  borderColor: "#1565c0",
                  color: "#1565c0",
                },
              }}
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
